module.exports = __webpack_public_path__ + "static/media/brazil_flag_2.88de68c5.png";